import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

function isTokenTimestampExpired(timestamp) {
  return Date.now() >= timestamp;
}

function logout() {
  store.dispatch('userStore/logout').then(() => router.next('/'));
}

router.beforeEach((to, from, next) => {
  // Redirect to login page if not logged in and trying to access a restricted page.
  const publicPages = ['/'];
  const authRequired = !publicPages.includes(to.path);
  const storedUser = localStorage.getItem('user');
  const { isClientConnectedToServer } = store.state.userStore;

  if (authRequired && !storedUser) {
    return next('/');
  }

  // Load user data from local storage if not yet in store.
  const { user } = store.state.userStore;
  if (!user) {
    const currentUser = JSON.parse(localStorage.getItem('user'));
    if (currentUser) {
      if (isTokenTimestampExpired(currentUser.jwtExiresAt) && isClientConnectedToServer) {
        logout();
      } else {
        store.dispatch('userStore/setUserFromLocalStorage', currentUser);
      }
    }
  } else if (isTokenTimestampExpired(user.jwtExiresAt) && isClientConnectedToServer) {
    logout();
  }

  // Prevent route access if route is restricted by role.
  const loggedInUser = store.state.userStore.user;
  const allowedRoles = to.meta.restrictToRoles;
  if (allowedRoles) {
    const userRoles = loggedInUser.roles;
    const intersection = userRoles.filter((x) => allowedRoles.includes(x));
    if (!intersection.length > 0) {
      return next('/unauthorized');
    }
  }
  return next();
});

export default router;
